import { Plus, Copy } from "lucide-react";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useTran } from "@/hooks";
import { PATHS } from "@/lib/router";
import { useEffect, useMemo } from "react";
import { Can } from "@/hooks/useCan/Can";
import { useAuthStore } from "@/features/auth";

const TargetSettingsHeaderActions = observer(() => {
  const { t } = useTran();
  const navigate = useNavigate();
  const { user } = useAuthStore();

  const permissions = useMemo(
    () => user?.permissions || [],
    [user?.permissions],
  );

  return (
    <div className="flex flex-wrap items-center gap-2">
      <div>
        <Can
          resource="carbon_target"
          action="create"
          userPermissions={permissions}
        ></Can>
      </div>
      <Button onClick={() => navigate(PATHS.CARBON_TARGETS_NEW)}>
        <Plus className="mr-2 h-4 w-4" />
        {t("Add Target Settings")}
      </Button>
    </div>
  );
});

export default TargetSettingsHeaderActions;
